// src/components/Inputs/ColorCheckboxInputs.jsx

'use client';

import { memo } from 'react';
import { capitalize } from '@/lib/functions.utils';
import CheckboxInputs from './CheckboxInputs'; // Import the flexible CheckboxInputs
import styles from './ColorCheckboxInputs.module.scss';


// Custom rendering function for Color Checkbox items
// Returns the structure EXACTLY as needed by the original CSS
const ColorRenderItem = ({
  key,
  value,
  displayLabel,
  isChecked,
  handleChange,
  itemData,
  placing,
}) => {
  const uniqueId = `${placing}-checkbox-${value}`;
  // This structure should match what your original CSS expects inside the container
  return (
    <div key={key} className={`${styles.colorItem} ${isChecked ? styles.selected : ''}`}>
      <input
        id={uniqueId}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        name={displayLabel}
        value={value}
        className={styles.visuallyHidden}
      />
      <label htmlFor={uniqueId}>
        <div className={styles.colorCircle} style={{ background: itemData.styleColor }} />
        <span className={styles.colorName}>{capitalize(displayLabel)}</span>
      </label>
    </div>
  );
};

const ColorCheckboxInputs = ({ colorCodeSetData, filterName, icon, legend, lang = 'en' }) => {

  return (
    <CheckboxInputs
      codeSetData={colorCodeSetData}
      filterName={filterName}
      icon={icon}
      legend={legend}
      lang={lang}
      // Provide the custom renderer
      renderItem={ColorRenderItem}
      // CRUCIAL: Pass the original container's class via containerProps
      // CheckboxInputs will now use a 'div' and apply this class.
      containerProps={{
         className: styles.colorSelectorContainer
      }}
    />
  );
};

export default memo(ColorCheckboxInputs);
